import {
  Button,
  FormControl,
  FormErrorMessage,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { Field, Form, Formik, FormikProps } from 'formik';
import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { updateCategory } from '../api/services';
import { resetCategoryToUpdate } from '../redux/slices/categoryToUpdateSlice';
import { useAppDispatch, useAppSelector } from '../redux/store';

interface MyEditableModalProps {
  isOpen: boolean;
  onClose: () => void;
  headerText: string;
  submitBtnText: string;
  cancelBtnText: string;
  onSubmitBtnClick?: React.MouseEventHandler<HTMLButtonElement>;
  isSubmitBtnLoading?: boolean;
  editable?: boolean;
  categoryInputValue: string;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
}

export const MyEditableModal: React.FC<MyEditableModalProps> = ({
  isOpen,
  onClose,
  headerText,
  submitBtnText,
  cancelBtnText,
  setFieldValue,
  categoryInputValue,
}) => {
  // get client states: categoryToUpdate
  const categoryToUpdate = useAppSelector((state) => state.categoryToUpdate);
  const dispatch = useAppDispatch();

  // get server states
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(updateCategory, {
    onSuccess: (updatedData) => {
      console.log('category updated');
      queryClient.setQueriesData('services', updatedData);
      // reset client state `categoryToUpdate`
      dispatch(resetCategoryToUpdate());
      // close modal
      onClose();
    },
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} blockScrollOnMount={true}>
      <ModalOverlay />
      <ModalContent
        borderRadius="3px"
        mt={'0'}
        mb={'0'}
        width={'90%'}
        bottom="21px"
        position={'absolute'}
      >
        <Formik
          initialValues={{ newCategory: categoryToUpdate }}
          onSubmit={() => console.log('hihihih')}
        >
          {({ values }: FormikProps<{ newCategory: string }>) => (
            <Form>
              <ModalHeader
                paddingBottom="0px"
                paddingLeft="17px"
                fontWeight="400"
              >
                {headerText}
              </ModalHeader>

              <ModalBody paddingLeft="17px" color={'#888'}>
                {
                  <div>
                    <Field name="newCategory">
                      {({ field, form }: any) => (
                        <FormControl
                          isInvalid={form.errors.name && form.touched.name}
                        >
                          <Input
                            {...field}
                            id="newCategory"
                            variant="myinput"
                            color={'#000'}
                            // placeholder="Entertainment"
                          />
                          <FormErrorMessage>
                            {form.errors.name}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </div>
                }
              </ModalBody>

              <ModalFooter h={'70px'}>
                {/* <ModalFooter h={'60px'} bgColor={'red'}> */}
                <Button
                  mr={3}
                  onClick={onClose}
                  padding={'0 20px'}
                  height="34px"
                  variant="solid"
                  bg="#fff"
                  border={'solid 1px #eee'}
                  color="#111"
                  fontWeight="400"
                  borderRadius="3px"
                  fontSize="15px"
                  letterSpacing="0.3px"
                  _hover={{ bg: '#fafafa' }}
                  _active={{ bg: '#f0f0f0' }}
                >
                  {cancelBtnText}
                </Button>

                <Button
                  // styles
                  padding={'0 20px'}
                  height="34px"
                  variant="solid"
                  bg="black"
                  color="#fff"
                  fontWeight="400"
                  borderRadius="3px"
                  fontSize="15px"
                  letterSpacing="0.3px"
                  _hover={{ bg: '#141414' }}
                  _active={{ bg: '#2b2b2b' }}
                  // other button props
                  type="submit"
                  onClick={() => {
                    mutate({
                      oldCategory: categoryToUpdate,
                      newCategory: values.newCategory,
                    });

                    if (categoryToUpdate === categoryInputValue) {
                      // setInput(values.newCategory);
                      setFieldValue('category', values.newCategory);
                    }
                  }}
                  isLoading={isLoading}
                >
                  {submitBtnText}
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalContent>
    </Modal>
  );
};
